import { useEffect } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router'
import { inject, observer } from 'mobx-react'

import { useTheme } from '@emotion/react'
import { css } from '@emotion/css'
import posed, { PoseGroup } from 'react-pose'

import SetupEmail from './SetupEmail'
import SetupAccount from './SetupAccount'
import ResetPassword from './ResetPassword'
import EnterAuthCode from './EnterAuthCode'
import Login from './Login'
import { API_URL } from '../../api'
import { withRouterProps } from '../../utils'
import { Page } from './elements'
import BGRight from '../../assets/images/BGRight.svg'

const RouteContainer = posed.div({
  enter: { opacity: 1, delay: 300, beforeChildren: true },
  exit: { opacity: 0 },
})

function LoginDashboard() {
  const location = useLocation()
  const theme = useTheme()

  useEffect(() => {
    document.documentElement.className = css`
      background: url(${API_URL && theme.bgRight ? API_URL + theme.bgRight : BGRight}) no-repeat top
        right fixed;
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;
    `
    return () => {
      document.documentElement.className = ''
    }
  })

  return (
    <PoseGroup animateOnMount>
      <RouteContainer key={location.key || location.pathname}>
        <Page.Container>
          <Routes location={location}>
            <Route path='register/setup-account' element={<SetupAccount />} />
            <Route path='register/enter-auth-code/:type' element={<EnterAuthCode />} />
            <Route path='register/:ref?' element={<SetupEmail />} />
            <Route path='reset-password/*' element={<ResetPassword />} />
            <Route path='login' element={<Login />} />
            <Route path='*' element={<Navigate to='/atmos/login' replace />} />
          </Routes>
        </Page.Container>
      </RouteContainer>
    </PoseGroup>
  )
}

export default withRouterProps(inject('store')(observer(LoginDashboard)))
